import { render, staticRenderFns } from "./EmptyDashboardItem.vue?vue&type=template&id=8d579f5c&"
import script from "./EmptyDashboardItem.vue?vue&type=script&lang=js&"
export * from "./EmptyDashboardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
